import Call from '../Call.v2';
import {objToQs} from '../Utils';

const BidderSpy = {
    get(filters) {
        return Call(`bidder/spy/?${objToQs(filters)}`);
    },

    getAffids(hash) {
        return Call(`bidder/spy/affids/${hash}`);
    },
};

export default BidderSpy;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderSpy.js